import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { notification } from "antd";
import InventoryService from "services/InventoryService";
export const initialState = {
  data: [],
  dataOutlet: [],
  dataDetail: [],
  currentStock: 0,
  loading: false,
  error: null,
  redirect: false,
};

export const fetchInventoryOutletData = createAsyncThunk(
  "inventory/fetchInventoryOutletData",
  async (data, { rejectWithValue }) => {
    try {
      const { page, pageSize, sort, searchText } = data;
      const response = await InventoryService.get({
        page,
        pageSize,
        sort,
        searchText,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const fetchInventoryData = createAsyncThunk(
  "inventory/fetchInventoryData",
  async (data, { rejectWithValue }) => {
    try {
      const { searchOutlet, searchProduct, endDate } = data;
      const response = await InventoryService.getReport({
        searchOutlet,
        searchProduct,
        endDate,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const fetchInventoryDetail = createAsyncThunk(
  "inventory/fetchInventoryDetail",
  async (id, { rejectWithValue }) => {
    try {
      const response = await InventoryService.getById(id);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const updateInventoryData = createAsyncThunk(
  "inventory/updateInventoryData",
  async (data, { rejectWithValue }) => {
    try {
      // const { id, inventory } = data;
      const response = await InventoryService.updateInventory(data);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const inventorySlice = createSlice({
  name: "inventory",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
    updateCurrentStock: (state, action) => {
      state.currentStock = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInventoryOutletData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchInventoryOutletData.fulfilled, (state, action) => {
        state.loading = false;
        state.dataOutlet = action.payload.data;
      })
      .addCase(fetchInventoryOutletData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchInventoryData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchInventoryData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(fetchInventoryData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchInventoryDetail.pending, (state) => {
        state.redirect = false;
        state.loading = true;
      })
      .addCase(fetchInventoryDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.dataDetail = action.payload.data;
        state.error = null;
      })
      .addCase(fetchInventoryDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateInventoryData.pending, (state) => {
        state.redirect = false;
        state.loading = true;
      })
      .addCase(updateInventoryData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        notification.success({ message: "Proses Berhasil" });
        state.redirect = true;
      })
      .addCase(updateInventoryData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { showLoading, updateCurrentStock } = inventorySlice.actions;

export default inventorySlice.reducer;
